import { Form, SubTitle } from './styles'
import { Div } from '../../styles'

const Hero = () => (
  <Form>
    <Div>
      <SubTitle>
        As melhores vagas para tecnologia, design e artes visuais.
      </SubTitle>
    </Div>
  </Form>
)

export default Hero
